import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { ProcessSection } from '../components/landing/ProcessSection';
import { ProofSection } from '../components/landing/ProofSection';
import { FAQSection } from '../components/landing/FAQSection';
import { OfferSection } from '../components/landing/OfferSection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0e1a] text-slate-300 font-sans selection:bg-[#00d4ff]/30 selection:text-white" data-id="element-212">
      <HeroSection data-id="element-213" />
      <ProblemSection data-id="element-214" />
      <SolutionSection data-id="element-215" />
      <ProcessSection data-id="element-216" />
      <ProofSection data-id="element-217" />
      <FAQSection data-id="element-218" />
      <OfferSection data-id="element-219" />
      <Footer data-id="element-220" />
    </main>;
}